import { Box, Chip, Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from '../../../components/EmptyState';
import getActiveLanguage from '../../../helpers/getActiveLanguage';
import { IngredientItem } from '../../../models/Ingredient';

type Item = Omit<IngredientItem, 'ingredient_group'>;

interface Props {
  items: Item[];
  onDelete: (item: Item) => void;
  onEdit: (item: Item) => void;
  hasMoreVertItemPermission: boolean;
}

function ItemsList({
  items,
  onDelete,
  onEdit,
  hasMoreVertItemPermission,
}: Props) {
  const { t } = useTranslation('ingredient');

  return (
    <Box>
      {items.length ? (
        <Grid container spacing={1.5}>
          {items.map(item => (
            <Grid item key={item.id}>
              <Chip
                disabled={!hasMoreVertItemPermission}
                color="info"
                label={getActiveLanguage(item.translations).name}
                onDelete={() => onDelete(item)}
                onClick={() => onEdit(item)}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <EmptyState message={t('items.empty')} />
      )}
    </Box>
  );
}

export default ItemsList;
